import React from 'react';
import { Typography, Paper, Button, Grid } from '@mui/material';
import CustomerLayout from '../CustomerLayout'; // ✅ Ensure this exists

const VideoTutorials = () => {
  const handleWatchTutorial = (tutorialType) => {
    // Implement logic for watching tutorials
    console.log(`Watching ${tutorialType} tutorial`);
  };

  return (
    <CustomerLayout>
    <Paper elevation={3} style={{ padding: '20px', marginBottom: '20px' }}>
      <Typography variant="h4" gutterBottom>Video Tutorials</Typography>

      {/* Getting Started Tutorials */}
      <Paper elevation={1} style={{ padding: '30px', marginBottom: '20px' }}>
        <Typography variant="h5" gutterBottom>Getting Started</Typography>
        <Typography variant="body1">Watch these video tutorials to get started with our products/services.</Typography>
        {/* Include video links or embeds */}
        {/* Example Button */}
        <Button variant="contained" color="primary" onClick={() => handleWatchTutorial('Getting Started')} style={{ marginTop: '10px' }}>
          Watch Getting Started Tutorial
        </Button>
      </Paper>

      {/* Advanced Features Tutorials */}
      <Paper elevation={1} style={{ padding: '30px' }}>
        <Typography variant="h5" gutterBottom>Advanced Features</Typography>
        <Typography variant="body1">Explore advanced features through our video tutorials.</Typography>
        {/* Include video links or embeds */}
        {/* Example Button */}
        <Button variant="contained" color="primary" onClick={() => handleWatchTutorial('Advanced Features')} style={{ marginTop: '10px' }}>
          Watch Advanced Features Tutorial
        </Button>
      </Paper>

      {/* Add more video tutorials as needed */}
    </Paper>
    </CustomerLayout>
  );
};

export default VideoTutorials;
